import { canSeeAdminAccessTab, canSeeLicenseTabs } from "@shared/api";
import { useUserContext } from "@shared/contexts";

/**
 * Indica quais abas do módulo Admin o usuário corrente pode ver.
 *
 * - `canSeeAccessTab`: aba "Acessos". Com o fim do papel `superAdmin`, é visível
 *   APENAS para owner / ownerViewer (leitura de Complex Admins; atribuição é
 *   owner-only). complexAdmin (client ou tellus) e user puro NÃO veem a aba.
 * - `canSeeLicenseTabs`: abas "Inventário de licenças" e "Alocações de licença".
 *   Ocultas APENAS para complexAdmin `tellus` (dispensam licença para módulos
 *   operacionais). owner/ownerViewer e complexAdmin `client` continuam vendo.
 *
 * Derivado localmente de `me.tenantAccess` (GET /v1/user/me) — sem sondar
 * `/v1/admin/*`. Contrato: docs/prd/admin/admin-endpoints.md §0 e §4; regras:
 * docs/permissions.md.
 */
export const useAdminAccessTabVisibility = () => {
  const { user: me } = useUserContext();

  return {
    canSeeAccessTab: canSeeAdminAccessTab(me?.tenantAccess),
    canSeeLicenseTabs: canSeeLicenseTabs(me?.tenantAccess),
    isResolving: false,
  } as const;
};
